import { Bad } from '@core/model/framework/Result/BadResult';
import { Ok } from '@core/model/framework/Result/OkResult';
import { BankService } from '@core/model/service/bankService';
import { bankConnections } from '@core/test/fixture/bankConnections.fixture';
import { GetBankConnectionsInput, GetBankConnectionsOutput } from '@core/usecase/getBankConnections';
import { GetBanksOutput } from '@core/usecase/getBanks';
import { GetWebauthUrlInput, GetWebauthUrlOutput } from '@core/usecase/getWebauthUrl';
import {
  SaveWebauthBankConnectionInput,
  SaveWebauthBankConnectionOutput,
} from '@core/usecase/saveWebauthBankConnection';
import { injectable } from 'inversify';

@injectable()
export class IMBankService implements BankService {
  getWebauthUrl(_input: GetWebauthUrlInput): GetWebauthUrlOutput {
    throw new Error('Method not implemented.');
  }
  getBanks(): GetBanksOutput {
    throw new Error('Method not implemented.');
  }
  async getBankConnections(input: GetBankConnectionsInput): GetBankConnectionsOutput {
    if (input.userId === 'OK') {
      return Ok(bankConnections);
    }
    if (input.userId === 'GET_BANK_CONNECTION_FAILED') {
      return Bad('GET_BANK_CONNECTION_FAILED');
    }
    throw new Error('UNEXPECTED');
  }
  async saveWebauthBankConnection(input: SaveWebauthBankConnectionInput): SaveWebauthBankConnectionOutput {
    if (input.webauthPopupUserToken === 'OK') {
      return Ok();
    }
    if (input.webauthPopupUserToken === 'SAVE_BANK_CONNECTION_DENIED') {
      return Bad('SAVE_BANK_CONNECTION_FAILED');
    }
    throw new Error('UNEXPECTED');
  }
}
